import {createRef, useEffect, useState} from 'react';

import TextArea from './TextArea';
import _kc from '../../../../../utils/keycloak';
import {ASIDE_NODE, ASIDE_EDGE} from '../../../../../utils/settings';

import {Header, Body} from './Box';
import styles from '../../../../../styles/case/aside/CustomBox.module.scss';

/**
 * @param {function} props.setCustomNote
 * @param {string} props.type
 * @param {Object} props.content
 *
 * @param {DataSet} props.nodes
 * @param {DataSet} props.edges
 */
function CustomBox(props) {
  const [show, setShow] = useState(true);
  const toggle = () => setShow(show => !show);
  const inputRef = createRef();
  const textRef = createRef();

  function cancelEvent(event) {
    props.setCustomNote(null);
  }

  function saveEvent(event) {
    if (inputRef.current.value.trim() === '' || textRef.current.value.trim() === '') return;

    const newInfo = {
      label: inputRef.current.value,
      content: [{
        source: _kc.tokenParsed.preferred_username,
        comment: textRef.current.value,
        timestamp: Date.now()
      }],
      custom: true
    };

    let newContent;
    if (props.type === ASIDE_EDGE) {
      props.edges.update({
        id: props.content.id,
        info: [newInfo, ...props.content.info]
      });
      newContent = props.edges.get(props.content.id);
    } else if (props.type === ASIDE_NODE) {
      props.nodes.update({
        id: props.content.id,
        info: [newInfo, ...props.content.info]
      });
      newContent = props.nodes.get(props.content.id);
    }
    props.setContent(newContent);
    props.setCustomNote(null);
  }

  // function onDelete(event) {
  //   event.preventDefault();
  //   if (!window.confirm('Are you sure you want to delete this note?')) return;

  //   let newContent;
  //   if (props.type === ASIDE_EDGE) {
  //     newContent = props.edges.get(props.content.id).content;
  //   } else if (props.type === ASIDE_NODE) {
  //     newContent = props.nodes.get(props.content.id).content;
  //   }
  //   console.log(JSON.stringify(newContent, null, 2))
  // }

  return (
    <div className={styles.customBox}>
      <Header className={styles.header} custom={true} onDoubleClick={toggle}>
        <input type='text' placeholder='Label' ref={inputRef} defaultValue='Notes'/>
        {/* <FontAwesomeIcon icon={show ? faMinus : faPlus} onClick={toggle}/> */}
      </Header>

      <Body className={styles.body} show={show}>
        <TextArea ref={textRef}/>
      </Body>

      <div className={styles.footer}>
        <button onClick={cancelEvent}>cancel</button>
        <button onClick={saveEvent}>save</button>
      </div>
    </div>
  );
}

export default CustomBox;